module.exports = __webpack_public_path__ + "media/packs/src/assets/images/main-slide-img-45920dadcf3a4a8ff6aa5c5eb4ccb88b.png";